export default __webpack_public_path__ + "static/0055-ed39de5e68e26e969242dafd0189d355.png";